import { Button } from "components/Button/Button"
import { ErrorStatus } from "components/ErrorStatus/ErrorStatus"
import { usePollingWithMax } from "hooks/usePollingWithMax"
import { Feedback } from "./Feedback"
import { useFootprint } from "./useFootprint"

export function DeviceSwUpdate() {
	const footprint = useFootprint()
	const pollCheckProgress = usePollingWithMax(footprint.swUpdateProgressCheck, {
		pollingInterval: 3000,
		maxCalls: 16,
		ready: !footprint.isUpdateSuccess,
		shouldBreak: () => !!footprint.isUpdateSuccess,
	})
	const mightNeedUpdate =
		!footprint.isUpdating &&
		!footprint.isUpdateError &&
		!footprint.isUpdateSuccess
	const spinning =
		!!footprint.executing.SWUPDATETRIGGER ||
		!!footprint.executing.SWUPDATEPROGCHECK ||
		!!footprint.isUpdating ||
		pollCheckProgress.loading
	const handleOk = async () => {
		if (footprint.isUpdating || footprint.isUpdateError) {
			const version = await footprint.getVersion()
			await footprint.swUpdateProgressCheck(version)
		} else if (mightNeedUpdate) {
			const version = await footprint.getVersion()
			await footprint.softwareUpdate()
			await footprint.swUpdateProgressCheck(version)
			pollCheckProgress.run()
		}
	}

	return (
		<Feedback spinning={spinning}>
			<div className="flex flex-col gap-2 rounded-2xl bg-mint-0 p-6">
				<h3 className="font-nunito text-2xl font-semibold text-mint-100">
					Device software update
				</h3>
				<div className="flex flex-col gap-4">
					{footprint.isUpdating && "The Footprint's software is updating..."}

					{(footprint.isUpdateError || mightNeedUpdate) && (
						<div className="flex flex-col gap-2">
							The Footprint's software might need to be updated.
							<ErrorStatus
								show={footprint.isUpdateError && footprint.message}
							>{`Error updating: ${footprint.message}`}</ErrorStatus>
						</div>
					)}

					{footprint.isUpdateSuccess && "The Footprint is up-to-date."}

					{!footprint.isUpdateSuccess && (
						<Button
							type="primary"
							className="w-full"
							disabled={
								!footprint.serialNumber || !!spinning || footprint.isUpdating
							}
							onClick={handleOk}
						>
							Check for update
						</Button>
					)}
				</div>
			</div>
		</Feedback>
	)
}
